/**
 * Content section: invite text, slogan, program.
 */

import { type ReactNode } from "react";
import { InlineTextPreview } from "../InlineFields.tsx";
import { SmartSection } from "../SmartSection.tsx";

export interface ContentSectionProps {
  id: string;
  inviteText: string;
  slogan: string;
  program: string;
  setEditingField: (
    f: "inviteText" | "slogan" | "program" | null,
  ) => void;
  icon: ReactNode;
  summary: string;
  filledCount: number;
  totalCount: number;
  hint?: string;
}

export function ContentSection({
  id,
  inviteText,
  slogan,
  program,
  setEditingField,
  icon,
  summary,
  filledCount,
  totalCount,
  hint,
}: ContentSectionProps) {
  return (
    <SmartSection
      id={id}
      title="Контент"
      icon={icon}
      summary={summary}
      filledCount={filledCount}
      totalCount={totalCount}
      hint={hint}
      defaultOpen={false}
    >
      <div className="card overflow-hidden">
        <InlineTextPreview
          label="Приглашение"
          value={inviteText}
          placeholder="Добавить..."
          onClick={() => setEditingField("inviteText")}
        />
        <InlineTextPreview
          label="Слоган"
          value={slogan}
          placeholder="Добавить..."
          onClick={() => setEditingField("slogan")}
        />
        <InlineTextPreview
          label="Программа"
          value={program}
          placeholder="Добавить..."
          onClick={() => setEditingField("program")}
        />
      </div>
    </SmartSection>
  );
}
